import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

// Formats a timestamp by its UTC calendar values, ignoring the viewer's
// timezone. Used for date-only windows (e.g. a report's default period) so the
// day shown matches the day that was picked regardless of local offset.
export const formatUtcDate = (date: string, format = 'YYYY-MM-DD') => {
  return dayjs.utc(date).format(format)
}

export const isFutureDate = (date: string | Date) => {
  return dayjs(date).isAfter(dayjs())
}

// We are using this function for sending the UTC date to server ignoring the user's timezone.
// F.ex. if a user chose 10am UTC+2 time 2024-08-30T10:00:00+02:00, we need to send 10am UTC time: 2024-08-30T10:00:00Z
export const formatLocalDateToUtcWithoutOffset = (date: string | Date) =>
  dayjs(date).utcOffset(0, true).format('YYYY-MM-DDTHH:mm:ss[Z]')

export const formatDateToUtcWithoutMilliseconds = (date: string | Date) =>
  dayjs(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
